import React from "react";
import EbSkeleton from "../../../ExecutionBlueprint/ExecutionBlueprintLiveReview/_shared/EbSkeleton";

// While the first `qokr_lr_details` lands: the same `eblr-body` split as the
// session (objectives ‖ Meeting Agenda), so nothing jumps when it arrives.
// Geometry comes from EXW's `eblr-skel-*` classes.
//
// ⚠️ SHARED WITH THE OTHER APP at the same folder depth — keep both copies equal.

const BANDS = [3, 2];

const LiveReviewSkeleton = () => (
  <div className="eblr-body" aria-busy="true">
    <div className="eblr-canvas">
      {BANDS.map((rows, band) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="eblr-skel-band" key={band}>
          <EbSkeleton className="eblr-skel-title" i={band} strong />
          {Array.from({ length: rows }).map((_, row) => (
            // eslint-disable-next-line react/no-array-index-key
            <EbSkeleton className="eblr-skel-row" key={row} i={band + row} />
          ))}
        </div>
      ))}
    </div>
    <div className="eblr-agenda">
      <div className="eblr-agenda-header">
        <EbSkeleton className="eblr-skel-agenda-title" strong />
      </div>
      <div className="eblr-agenda-body">
        {[0, 1, 2].map((card) => (
          <EbSkeleton className="eblr-skel-agenda-card" key={card} i={card} />
        ))}
      </div>
    </div>
  </div>
);

export default LiveReviewSkeleton;
